import { Routes } from '@angular/router';
import { Permissions } from 'src/app/core/common';
import { RoutesConstants } from 'src/app/shared/common';
import { PermissionGuard } from 'src/app/shared/guard/permission-guard';

export const EXTRACT_REPORTS_ROUTES: Routes = [
    {
        path: RoutesConstants.EXPORT_REPORTS_PAGE_URL,
        canActivate: [PermissionGuard],
        loadComponent: () => import('./pages/extract-reports-table/extract-reports-table.component').then(x => x.ExtractReportsTableComponent),
        data: {
            breadcrumb: {
                label: 'EXTRACT_REPORTS',
                icon: 'import_export'
            },
            permissions: [Permissions.Setting_Exported_Report]
        }
    }
]